import React from 'react';
import Login from '../../components/login'
function LoginLayout() {
  return (
      <Login/>
  );
}

export default LoginLayout;
